<script>
  import { _ } from "svelte-i18n";
  import { onMount } from "svelte";
  import MasonryProduct from "./MasonryProduct.svelte";
  import imagesLoaded from "imagesloaded";

  export let products = [];

  let tags = [];
  let topTags = [];
  let imageData = {};

  async function resize(products) {
    console.log(products?.length);

    if (products?.length < 1) return;

    var docWidth =
      document.documentElement.clientWidth || document.body.clientWidth;

    imagesLoaded(".masonry-products", function () {
      console.log("images are loaded");

      const masonryElem =
        document.getElementsByClassName("masonry-products")[0];
      let masonryImages = masonryElem.getElementsByClassName("masonry-image");
      masonryImages = Array.prototype.slice.call(masonryImages);
      const productListWidth = masonryElem.getBoundingClientRect().width; //+ imagePadding;
      let processedImages = [];

      for (let mi of masonryImages) {
        mi.getAttributeNames().forEach((att) => {
          if (att.startsWith("data-a3_")) mi.removeAttribute(att);
        });

        mi.style.height = "200px";
        mi.style.width = "auto";
        mi.closest(".masonry-item").style.minWidth = "initial";
      }

      for (let masonryImage of masonryImages) {
        console.log(masonryImage.dataset.a3_processed);

        if (!masonryImage.dataset.a3_originalHeight) {
          masonryImage.dataset.a3_originalHeight = masonryImage
            .getBoundingClientRect()
            .height.toString();
        }
        if (!masonryImage.dataset.a3_originalWidth) {
          masonryImage.dataset.a3_originalWidth = masonryImage
            .getBoundingClientRect()
            .width.toString();
        }

        masonryImage.dataset.a3_processed = "-1";
      }

      function resizeHeights({ masonryImages }) {
        let cumulWidth = 0;
        let lastCumulWidth = 0;

        console.log(masonryImages.length);

        for (let j = 0; j < masonryImages.length; j++) {
          let masonryImage = masonryImages[j];

          if (masonryImage.dataset.a3_processed != "-1") continue;

          // const currentImgWidth = masonryImage.getBoundingClientRect().width;
          const currentImgWidth = parseFloat(
            masonryImage.dataset.a3_originalWidth,
          );
          cumulWidth += currentImgWidth;

          if (cumulWidth > productListWidth) {
            const fitMore =
              Math.abs(cumulWidth - productListWidth) <
              Math.abs(productListWidth - lastCumulWidth);

            let row = masonryImages.splice(0, j + (fitMore ? 1 : 0));

            const newCumulWidth = fitMore ? cumulWidth : lastCumulWidth;

            const newRatio = productListWidth / newCumulWidth;

            for (let k = 0; k < row.length; k++) {
              const newWidth = newRatio * row[k].dataset.a3_originalWidth;
              const newHeight = newRatio * row[k].dataset.a3_originalHeight;

              row[k].dataset.a3_newWidth = newWidth;
              row[k].dataset.a3_newHeight = newHeight;

              console.log(
                JSON.stringify({
                  k,
                  j,
                  newRatio,
                  fitMore,
                  cumulWidth,
                  lastCumulWidth,
                }),
              );
            }

            processedImages = processedImages.concat(row);

            break;
          }

          lastCumulWidth = cumulWidth;
        }

        if (masonryImages.length > 0 && cumulWidth > productListWidth) {
          resizeHeights({ masonryImages });
        } else {
          processedImages = processedImages.concat(masonryImages);
        }
      }

      resizeHeights({ masonryImages });

      console.log({ processedImagesCount: processedImages.length });

      processedImages.forEach((pimg) => {
        const margin = docWidth > 768 ? 10 : 5;

        pimg.closest(".masonry-item").style.minWidth =
          pimg.dataset.a3_newWidth + "px";

        pimg.style.width =
          "calc(" + pimg.dataset.a3_newWidth + `px - ${margin * 2}px`;
        pimg.style.height =
          "calc(" + pimg.dataset.a3_newHeight + `px - ${margin * 2}px`;
        pimg.style.margin = `${margin}px ${margin}px`;

        console.log(
          pimg.closest(".masonry-item").style.width,
          pimg.closest(".masonry-item").style.height,
          pimg.dataset.a3_newWidth,
          pimg.dataset.a3_newHeight,
        );
      });
    });
  }

  let resizeTimer = null;

  onMount(() => {
    window.onresize = function () {
      clearInterval(resizeTimer);
      resizeTimer = setInterval(function () {
        if (products.length > 0) {
          resize(products);
          clearInterval(resizeTimer);
        }
      }, 10);
    };
  });

  function triggerResize(products) {
    setTimeout(function () {
      window.dispatchEvent(new Event("resize"));
    }, 0);
  }

  function filterTags(products) {
    for (const prod of products) {
      for (const tag of prod.tags) {
        if (topTags?.[tag.id]) {
          topTags[tag.id].count++;
        } else {
          topTags[tag.id] = {
            ...tag,
            count: 1,
          };
        }
      }
    }

    topTags.sort((a, b) => (a.count < b.count ? 1 : -1));
    console.log({ topTags });

    tags = topTags
      .slice(0, 50)
      .map((t) => ({ ...t, term_id: t.id, selected: false }));
  }

  // $: filterTags(products);
  $: console.log(triggerResize(products));
</script>

<!-- <TagList bind:tags /> -->

<div class="masonry-products">
  {#each products as product}
    <MasonryProduct {product} />
  {/each}
</div>

<style>
  .masonry-products {
    padding: 0px;
    margin: 0px;
    display: flex;
    flex-wrap: wrap;
  }
</style>
